import { useMutation } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { USER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { IIntegrateStudio } from '~/Models/DTO/IntegrateStudio.model';
import { useProvider } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';

interface IClientRole {
  clientId: string;
  redirectUrl: string;
}

export const useRequestConnectPublicApi = () => {
  const { currentProvider } = useProvider();

  return useMutation<IIntegrateStudio, IErrorResponse, IClientRole>(
    REQUEST_ACTIONS.POST_CLIENT_ROLE,
    async (params: IClientRole) =>
      requestReactQuery<IIntegrateStudio>({
        url: USER_SERVICE_URLS.PUBLIC_API_ROLES,
        config: { method: 'POST' },
        params: { ...params, providerId: currentProvider?.uuid },
      }),
  );
};
